import { render, staticRenderFns } from "./IngredientCreate.vue?vue&type=template&id=7e4e1b10&scoped=true&"
import script from "./IngredientCreate.vue?vue&type=script&lang=js&"
export * from "./IngredientCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4e1b10",
  null
  
)

export default component.exports